const CSV = '.csv';
const EXCEL = '.xlsx';
const EXCEL97 = '.xls';
const JPEG = '.jpeg';
const JPG = '.jpg';
const PNG = '.png';
const EPS = '.eps';
const TIF = '.tif';
const TIFF = '.tiff';

const ACCEPTED_IMAGES = {
  fileTypes: [JPEG, JPG, PNG],
  accept: {
    'image/png': [],
    'image/jpeg': [],
    'image/jpg': []
  }
};
const ACCEPTED_SHEETS = {
  fileTypes: [EXCEL, EXCEL97, CSV],
  accept: {
    'application/vnd.ms-excel': [],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
    'text/csv': []
  }
};
const ACCEPTED_LOGO_PREVIEW_IMAGES = {
  fileTypes: [JPEG, JPG, EPS, TIF, TIFF],
  accept: {
    'image/jpeg': [],
    'image/jpg': [],
    'image/eps': [],
    'image/tif': [],
    'image/tiff': []
  }
};

export {
  ACCEPTED_IMAGES,
  ACCEPTED_LOGO_PREVIEW_IMAGES,
  ACCEPTED_SHEETS,
  CSV,
  EXCEL,
  EXCEL97,
  JPEG,
  JPG,
  PNG
};
